import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { isNullOrUndefined } from '../../../../util/Utils'
import { MrnLink, PersonLink, TreePersonLink } from '../../../app/Links'

export default function SameSexDetectedMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const fatherPid = messageDetails?.fatherPersonId
  const fatherMrn = messageDetails?.fatherMembershipUuid
  const motherPid = messageDetails?.motherPersonId
  const motherMrn = messageDetails?.motherMembershipUuid

  const fatherSummary = queueCachesState.personsCache[fatherPid]
  const motherSummary = queueCachesState.personsCache[motherPid]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(fatherPid)
    queueCachesActions.fetchPersonSummary(motherPid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(fatherSummary) || isNullOrUndefined(motherSummary)) {
    return null
  }

  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('father', 'Father')}
          data={
            <>
              <PersonLink personId={fatherPid} personName={fatherSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={fatherPid} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('fatherMrn', 'Father MRN')} data={<MrnLink mrn={fatherMrn} newTab />} />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('mother', 'Mother')}
          data={
            <>
              <PersonLink personId={motherPid} personName={motherSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={motherPid} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('motherMrn', 'Mother MRN')} data={<MrnLink mrn={motherMrn} newTab />} />
      </Cell>
    </Grid>
  )
}
